import { ReactNode } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IconHidden } from "src/components/icons-mui/hidden";
import { Typography } from "src/components-mui/base/typography/typography";

interface IPortfolioTableErrorStateProps {
    children: ReactNode;
}

export const PortfolioTableErrorState = ({ children }: IPortfolioTableErrorStateProps) => {
    const { t } = useTranslation("common");

    return (
        <Box sx={{ position: "relative" }}>
            {children}
            <Box sx={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Box
                    sx={{
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        px: 4,
                        pt: 4,
                        pb: 1.5,
                        backgroundColor: "common.white",
                        boxShadow: 1,
                        borderRadius: 1,
                    }}
                >
                    <IconHidden sx={{ position: "absolute", top: "-70px", width: theme => theme.spacing(17), height: theme => theme.spacing(17) }} />
                    <Typography
                        component="p"
                        sx={{ fontSize: "lg", fontWeight: "semibold", backgroundColor: "common.white", p: 0.5, mt: 0.5, textAlign: "center" }}
                    >
                        {t("no-data")}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
